// initial state
const state = () => ({
  accounts: []
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  SET_ACCOUNTS (state, accounts) {
    state.accounts = accounts
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}